import { makeStyles } from '@mui/styles';
import { FormControlLabel, Radio, RadioGroup } from '@ori-ui/mui';
import React from 'react';

import { useAppContext } from '../../../contexts';
import { useTranslationByKey } from '../../../helpers/useTranslationByKeys';
import { TranslationKey } from '../../../models';
import { NotifyTypeEnum } from '../helpers/NotifyTypeEnum';

export interface NotifyTypeProps {
    currentType: string;
    handleOnChange: (event: React.FormEvent<HTMLInputElement>) => void;
}

const useClassNames = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        color: theme.palette.text.primary,
        fontSize: '14px',
        lineHeight: '21px',
        margin: '0 30px 15px 0',

        [theme.breakpoints.up(768)]: {
            flexDirection: 'row',
            marginBottom: '18px',
        },
    },
}));

export const NotifyType: React.FC<NotifyTypeProps> = ({ currentType, handleOnChange }) => {
    const { notifyMeSubscriptionConfiguration } = useAppContext();
    const t = useTranslationByKey();
    const classNames = useClassNames();

    return (
        <RadioGroup
            className={classNames.root}
            aria-label="Choose an option"
            name="pdp-notify-choose"
            value={currentType}
            onChange={handleOnChange}
        >
            <FormControlLabel
                id="pdp-notify-email"
                value={NotifyTypeEnum.email}
                control={<Radio color="primary" />}
                label={t(TranslationKey.email)}
            />
            {notifyMeSubscriptionConfiguration.IsSmsSubscriptionEnabled && (
                <FormControlLabel
                    id="pdp-notify-sms"
                    value={NotifyTypeEnum.sms}
                    control={<Radio color="primary" />}
                    label={t(TranslationKey.sms)}
                />
            )}
        </RadioGroup>
    );
};
